import Vue from "vue";
import collect from "collect.js";
import VueSweetalert2 from "vue-sweetalert2";
import SimpleVueValidation from "simple-vue-validator";
import FileUploader from "./components/file-uploader.vue";

import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(SimpleVueValidation);
Vue.use(VueSweetalert2);

const Validator = SimpleVueValidation.Validator;

const api = JSON.parse(document.getElementById("api").textContent);
const old = JSON.parse(document.getElementById("old").textContent);

const app = new Vue({
    el: "#app",
    components: {
        FileUploader
    },
    data: {
        name: "",
        email: "",
        phone: "",
        company: "",
        region_id: "",
        country_required: true,
        country_id: "",
        solution: "",
        type: "",
        product: "",
        origin: [],
        regions: [],
        region: {},
        solutions: [],
        types: [],
        products: [],
        onSumit: false
    },
    mounted() {
        this.regions = api.regions;
        this.origin = collect(api.categories);
        this.solutions = this.origin
            .flatMap(value => {
                return { id: value.id, title: value.title };
            })
            .all();
        this.types = [];
        this.products = [];
        if (Object.keys(old).length > 0) {
            this.name = old.name;
            this.email = old.email;
            this.phone = old.phone;
            this.company = old.company;
            this.region_id = old.region_id;
            this.country_id = old.country_id;

            this.solution = old.product_solution_id;
            this.changeSolution();
            this.type = old.product_type_id;
            this.changeType();
            this.product = old.product_id;
        }
    },
    validators: {
        name: function(value) {
            return Validator.value(value).required();
        },
        email: function(value) {
            return Validator.value(value)
                .required()
                .email();
        },
        phone: function(value) {
            return Validator.value(value).required();
        },
        company: function(value) {
            return Validator.value(value).required();
        },
        region_id: function(value) {
            return Validator.value(value).required();
        },
        country_id: function(value) {
            if (this.country_required) {
                return Validator.value(value).required();
            }
        },
        solution: function(value) {
            return Validator.value(value).required();
        },
        type: function(value) {
            return Validator.value(value).required();
        },
        product: function(value) {
            return Validator.value(value).required();
        }
    },
    methods: {
        changeSolution: function() {
            this.type = "";
            this.product = "";

            const types = this.origin.firstWhere("id", parseInt(this.solution));
            this.types = types !== null ? types.subs : [];
            this.products = [];
        },
        changeType: function() {
            this.product = "";

            const data = collect(this.types).firstWhere(
                "id",
                parseInt(this.type)
            );
            this.products = data.products !== null ? data.products : [];
        },
        changeRegion: function() {
            this.region = {};
            const row = collect(this.regions).firstWhere(
                "id",
                parseInt(this.region_id)
            );
            this.region = row !== null ? row : {};
            this.country_required =
                row.country_required !== undefined ? row.country_required : 0;
        },
        submit(formId) {
            if (!this.onSumit) {
                this.$validate().then(success => {
                    if (success) {
                        var response = grecaptcha.getResponse();
                        if (response.length === 0) {
                            this.$swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Check the I'm not a robot"
                            });
                        } else {
                            this.onSumit = true;
                            document.getElementById(formId).submit();
                        }
                    }
                });
            }
        }
    }
});
